export enum GoogleLoginStatus {
	SKIPPED = 'skipped',
	DISMISSED = 'dismissed',
}
